module.exports = __webpack_public_path__ + "static/img/theme5.9e099bf5.png";